export default __webpack_public_path__ + "2a8a99c6606b892fca09594e310915be.png";